import { AfterViewInit, Component, effect, Input, OnInit, ViewChild } from '@angular/core';
import { SurveyCreatorModel } from "survey-creator-core";
import { SurveyCreatorModule } from 'survey-creator-angular';
import SurveyCreatorTheme from "survey-creator-core/themes";
import { registerCreatorTheme } from "survey-creator-core";
import * as Survey from 'survey-core';
import * as SurveyCreatorCore from 'survey-creator-core';
import { ComponentCollection, Question, settings, surveyStrings } from 'survey-core';
import { getLocaleStrings } from "survey-creator-core";
import { slk } from "survey-core";
import { SubHeaderComponent } from '@sml/sub-header';
import { ActivatedRoute, Router } from '@angular/router';
import { AppFormService, CommunitySignalService, ICommunity, IFormMaster, TooltipDirective, ViewParticipateService, AppTemplateFormService, ITemplateFormMaster } from '@sml/utility';
import { IconsComponent } from '@sml/icons';
import { ButtonsModule } from '@sml/buttons';
import { Serializer } from "survey-core";
import { environment as env } from '@env/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { customThemeVariables } from './theme._json';
import { DialogComponent } from '@sml/dialog';
import { SvgRegistry } from "survey-core";
import { arrowIcon, dedicatedTo, donatedBy, email, fileUpload, longText, multiSelectDropdown, newSection, participantAddress, participantPhoto, phoneNumber, signature, singleLineInputText, singleSelectDropdown } from './icons';
import { ToastrService } from '@sml/toastr';

registerCreatorTheme(SurveyCreatorTheme); // Add predefined Survey Creator UI themes
SvgRegistry.registerIcon("icon-smiley-rate1-24x24", donatedBy);
SvgRegistry.registerIcon("icon-smiley-rate10-24x24", participantPhoto);
SvgRegistry.registerIcon("icon-smiley-rate2-24x24", dedicatedTo);
SvgRegistry.registerIcon("icon-smiley-rate3-24x24", participantAddress);
SvgRegistry.registerIcon("icon-toolbox-file-16x16", fileUpload);
SvgRegistry.registerIcon("icon-smiley-rate4-24x24", email);
SvgRegistry.registerIcon("icon-smiley-rate5-24x24", phoneNumber);
SvgRegistry.registerIcon("icon-toolbox-panel-24x24", newSection);
SvgRegistry.registerIcon("icon-toolbox-singleline-24x24", singleLineInputText);
SvgRegistry.registerIcon("icon-toolbox-longtext-24x24", longText);
SvgRegistry.registerIcon("icon-toolbox-signature-24x24", signature);
SvgRegistry.registerIcon("icon-toolbox-dropdown-24x24", singleSelectDropdown);
SvgRegistry.registerIcon("icon-toolbox-tagbox-24x24", multiSelectDropdown);
SvgRegistry.registerIcon("icon-search-24x24", arrowIcon);

@Component({
  selector: 'app-survey-builder',
  imports: [SurveyCreatorModule, ButtonsModule, SubHeaderComponent, FormsModule, IconsComponent, CommonModule, DialogComponent, TooltipDirective],
  templateUrl: './survey-builder.component.html',
  styleUrl: './survey-builder.component.scss',
  standalone: true,
})
export class SurveyBuilderComponent implements OnInit, AfterViewInit {
  @ViewChild('smlModal') smlModal!: DialogComponent;
  surveyCreatorModel!: SurveyCreatorModel;
  isEditing = false;
  showFormBuilder: boolean = false;
  public contactUs = 'Contact us: support@seemylegacy.com'
  isTitleEditing = false;
  isSaveClick = false;
  @Input() showDialogBox = false
  surveyCreator!: SurveyCreatorModel;
  itemState: Record<string, boolean> = {};
  savedItemState: Record<string, boolean> | undefined = {};
  private _formData!: IFormMaster;
  @Input()
  set formData(value: IFormMaster) {
    this._formData = value;
    if (value) {
      this.setLastModifiedData(value);
    }
    this.savedItemState = this._formData?.disabledFieldState;
  }
  get formData(): IFormMaster {
    return this._formData;
  }
  private _templateFormData!: ITemplateFormMaster;
  @Input()
  set templateFormData(value: ITemplateFormMaster) {
    this._templateFormData = value;
    if (value) {
      this.setLastModifiedData(value);
    }
    this.savedItemState = this._templateFormData?.disabledFieldState;
  }

  get templateFormData(): ITemplateFormMaster {
    return this._templateFormData;
  }

  get currentFormData() {
    return this.isTemplateForm ? this.templateFormData : this.formData;
  }

  isEdit = false;
  isTemplateForm = false; // Flag to check if it's a template form
  isItemAdded: boolean = false; // Flag to track if the item is added
  disable: boolean = false; // Flag to disable the toolbox item
  isUsed: boolean = false;
  formTitle: string = 'Form Title';  // Store form title
  formDescription: string = 'Form Description';  // Store form description
  lastModified?: string;  // Store last modified date
  basicFieldsInfo = 'Using these fields allow you to capture additional details from your participants. All custom details will be captured in the Activity Log.'
  publicRecognitionFieldsInfo = 'Using these fields allows your participations to be publicly recognized for their contribution with a photo, donor name, and/or dedication details. These fields will be displayed on their digital "Recognition Card".'
  newSectionInfo = 'Adding a New Section allows you to group fields together and add a Section title and description. Using Sections helps create a simple experience for your participants!'
  backText: string = ''
  creatorOptions = {
    showElementEditorAsPropertyGrid: false,
    allowEditQuestions: false,
    allowChangeQuestionType: false,
    maxPanelNestingLevel: 0,
    autoSaveEnabled: true,
    collapseOnDrag: false,
    showLogicTab: false,
    showTranslationTab: false,
    showTestSurveyTab: false,
    showJSONEditorTab: false,
    isAutoSave: false,
    showLogoTab: false,
    showSaveButton: false,
    showPagesInDesigner: false,
    pageEditMode: "single" as const,
    showToolbox: true,
    questionTypes: [
      "text",         // single-line text
      "comment",      // multi-line textarea
      "panel",        // panel to group questions
    ]
  };


  defaultJson = {
    "pages": [
      {
        "name": "page1",
        "elements": [
          {
            "type": "panel",
            "name": "ParticipantDetails",
            "title": "Participant Details",
            "elements": [
              {
                "type": "text",
                "name": "FirstName",
                "title": "First Name",
                "isRequired": true
              },
              {
                "type": "text",
                "name": "LastName",
                "startWithNewLine": false,
                "title": "Last Name",
                "isRequired": true
              },
              {
                "type": "text",
                "name": "Email",
                "title": "Email",
                "isRequired": true,
                "inputType": "email"
              },
              {
                "type": "text",
                "name": "Phone",
                "startWithNewLine": false,
                "title": "Phone Number",
                "inputType": "tel",
                "isRequired": true,
                "maskType": 'pattern',
                "maskSettings": {
                  "pattern": "(999) 999-9999"
                }
              },
              {
                "type": "text",
                "name": "OrganizationBusinessName",
                "title": "Organization, Business, or Family Name",
                "description": "Participating as a group? List name here."
              }
            ]
          },
        ]
      }
    ]
  }

  communityData!: ICommunity | undefined;
  isMobile: boolean = false;
  constructor(private communitySignalService: CommunitySignalService, private router: Router, private participateService: ViewParticipateService, private activatedRoute: ActivatedRoute, private readonly toastr: ToastrService,

    private appFormService: AppFormService, private readonly appTemplateFormService: AppTemplateFormService
  ) {
    effect(() => {
      this.communityData = this.communitySignalService.getCommunity();
    });
  }

  ngAfterViewInit(): void {
    const toolbox = this.surveyCreator.toolbox;
    setTimeout(() => {
      const sectionItem = toolbox.getItemByName("panel");
      if (sectionItem) {
        // 2. Remove it from the current position
        toolbox.removeItem("panel");
        // 3. Re-add it to the end
        toolbox.addItem(sectionItem);
      }
    }, 100);
  }

  openSurveySettingsPanel(): void {
    if (this.surveyCreator) {
      this.surveyCreator.showSidebar = !this.surveyCreator.showSidebar;
    }
  }

  ngOnInit() {
    this.isTemplateForm = this.router.url.includes('custom-template-form-builder');
    this.isMobile = window.innerWidth <= 768; // Adjust the width as needed
    this.showFormBuilder = window.innerWidth >= 1000;
    if (!this.showFormBuilder) {
      this.backText = !this.isTemplateForm ? 'Custom Forms' : 'Custom Template Forms';
    }
    else {
      this.backText = !this.isTemplateForm ? 'Back to Forms' : 'Back to Templates'
    }
    this.activatedRoute.queryParamMap.subscribe(params => {
      const formId = params.get('formId');
      const templateFormId = params.get('templateFormId');
      if (formId || templateFormId) {
        this.isEdit = true;
      }
      else {
        this.isEdit = false;
      }
    })
    this.changeSettingNames()
    this.addSurveyKey();
    this.surveyCreator = new SurveyCreatorModel(this.creatorOptions);
    this.changeAddQuestion(this.surveyCreator);
    this.surveyCreator.toolbox.defineCategories([

      {
        category: "Basic Fields",
        items: [
          "text", "comment", "checkbox", "dropdown", "tagbox", "file", "addressPanel", "phone", "email", "signaturepad",
        ]
      },
      {
        category: "Public Recognition Fields",
        items: ["DonatedBy", "DedicatedTo", "DonorRecognitionImage"]
      },
      {
        category: "New Section",
        items: ["panel"]
      }
    ], true);
    this.surveyCreator.toolbox.allowExpandMultipleCategories = false;
    this.surveyCreator.toolbox.showCategoryTitles = true;
    this.surveyCreator.toolbox.keepAllCategoriesExpanded = true;
    const creator = this.surveyCreator as any;
    creator.onSurveyInstanceCreated.add((_: any, options: any) => {
      options.survey.onUpdatePanelCssClasses.add((sender: any, options: any) => {
        options.cssClasses.panel.title += " custom-panel-title";
      });
    });
    this.hideSaveButton(this.surveyCreator);
    this.addCustomFields(this.surveyCreator);
    this.otherFunc(this.surveyCreator);
    this.protectFields(this.surveyCreator);
    this.changePanelName(this.surveyCreator);
    this.changeSettingNames();
    this.hideFieldSettingsForGlobalForm(this.surveyCreator);
    this.restrictSpecialChoices(creator);
    const customTheme = {
      themeName: "customTheme",
      cssVariables: { ...customThemeVariables }
    };
    this.surveyCreator.applyCreatorTheme(customTheme);
    this.surveyCreator.onElementSelected.add((sender, options) => {
      setTimeout(() => {
        const sidePanelEl = document.querySelector(".svc-side-bar");
        if (!sidePanelEl) return;

        const selectedType = sender.selectedElement?.getType?.();
        if (selectedType === "survey") {
          sidePanelEl.classList.add("tw-hidden");
        } else {
          sidePanelEl.classList.remove("tw-hidden");
        }
      })
    });
    this.surveyCreator.onPanelAdded.add(function (_, options) {
      const panel = options.panel;
      // Skip if it's a known custom panel like 'addressPanel'
      if (panel.name === 'addressPanel') return;
      // Apply default section title/description only to unnamed panels
      if (!panel.title) {
        panel.title = "Section Header";
      }
      // if (!panel.description) {
      //   panel.description = "Section Description";
      // }
    });

    // Restrict Drag/Drop within the form builder
    this.surveyCreator.onDragDropAllow.add((sender, options) => {
      const draggedElement = options.draggedElement;
      const draggedName = draggedElement?.name;
      const restrictedFields = ["FirstName", "LastName", "Email", "Phone","AddressLine1", "AddressLine2", "City", "State", "ZipCode"];
      if (restrictedFields.includes(draggedName)) {
        options.allow = false;
      }
    });

    //Restrict Drag/Drop Inside a Panel
    creator.onDragDropAllow.add((sender: any, options: any) => {
      const target = options.target;
      const draggedElement = options.draggedElement;
      const draggedName = draggedElement?.name || draggedElement?.json?.name;
      // Block dropping into the "ParticipantDetails" panel, except for OrganizationBusinessName
      if (target.parent?.name === "ParticipantDetails") {
        if (draggedName !== "OrganizationBusinessName") {
          options.allow = false;
        }
      }
      // Always block dropping into the "addressPanel"
      if (target.parent?.name === "addressPanel") {
        options.allow = false;
      }
    });

    // text: Default text input.
    // email: Email input with basic validation.
    // password: Password input (masked text).
    // tel: Telephone input (number pad on mobile devices).
    // url: URL input with URL validation.
    // color: Color picker input.
    // date: Date picker input.
    // datetime-local: Date and time picker input.
    // month: Month and year picker input.
    // time: Time picker input.
    //Remove items from Single Line Input Dropdown
    const subItemsToRemove = ["color", "email", "tel", "password", "url", "datetime-local", "month", "time", "range", "week"];
    const singleTextInputItem = this.surveyCreator.toolbox.getItemByName("text");
    if (singleTextInputItem && singleTextInputItem.removeSubitem) {
      subItemsToRemove.forEach((subitemName) => {
        singleTextInputItem.removeSubitem(subitemName);
      });
    }
    this.surveyCreator.showSidebar = false;
    //creator.text = window.localStorage.getItem("survey-json") || JSON.stringify(this.defaultJson);
    if (!this.isTemplateForm) {
      this.surveyCreator.JSON = !!this.formData?.schema === true ? JSON.parse(this.formData.schema) : this.defaultJson;
    }
    else {
      this.surveyCreator.JSON = !!this.templateFormData?.schema === true ? JSON.parse(this.templateFormData.schema) : this.defaultJson;
    }
    this.surveyCreatorModel = this.surveyCreator;
    
    // Check OrganizationBusinessName initial state after JSON is loaded
    setTimeout(() => {
      const updateToolboxState = (itemName: string, enabled: boolean) => {
        const item = this.surveyCreator.toolbox.getItemByName(itemName);
        if (item) item.enabled = enabled;
      };
      
      const orgFieldExists = this.checkIfFieldExistsInForm('OrganizationBusinessName');
      if (orgFieldExists) {
        this.itemState['OrganizationBusinessName'] = true;
        updateToolboxState('OrganizationBusinessName', false);
      } else {
        this.itemState['OrganizationBusinessName'] = false;
        updateToolboxState('OrganizationBusinessName', true);
      }
    }, 100);
    this.surveyCreator.saveSurveyFunc = (saveNo: number, callback: Function) => {
      // If you use localStorage:
      window.localStorage.setItem("survey-json", this.surveyCreator.text);
      callback(saveNo, true);
      if (!this.isTemplateForm) {
        this.formData = {
          ...this.formData,
          schema: this.surveyCreator.text,
          disabledFieldState: this.itemState
        }

        if (!this.formData.id && this.communityData?.id) {
          this.appFormService.saveFormData(this.formData, this.communityData?.id).subscribe({

            next: () => {
              if (this.isTemplateForm) {
                this.router.navigate(['/community', this.communityData?.id, 'custom-template-grid']);

              }
              else {
                this.router.navigate(['/community', this.communityData?.id, 'custom-grid']);
              }
            },

            error: (error) => {
              console.error('Error fetching table data', error);
            }
          });
        }
        else {
          this.appFormService.updateFormData(this.formData).subscribe({
            next: () => {
              if (this.isTemplateForm) {
                this.router.navigate(['/community', this.communityData?.id, 'custom-template-grid']);

              }
              else {
                this.router.navigate(['/community', this.communityData?.id, 'custom-grid']);
              }
            },

            error: (error) => {
              console.error('Error fetching table data', error);
            }
          });
        }
      }
      else {
        this.templateFormData = {
          ...this.templateFormData,
          schema: this.surveyCreator.text,
          disabledFieldState: this.itemState
        }
        if (!this.templateFormData.id && this.communityData?.id) {
          this.appTemplateFormService.createFormTemplate(this.templateFormData).subscribe({
            next: () => {
              if (this.isTemplateForm) {
                this.router.navigate(['/community', this.communityData?.id, 'custom-template-grid']);

              }
              else {
                this.router.navigate(['/community', this.communityData?.id, 'custom-grid']);
              }
            },
            error: (error) => {
              console.error('Error fetching table data', error);
            }
          });
        }
        else {
          this.appTemplateFormService.updateFormTemplate(this.templateFormData).subscribe({
            next: (data) => {
              if (this.isTemplateForm) {
                this.router.navigate(['/community', this.communityData?.id, 'custom-template-grid']);

              }
              else {
                this.router.navigate(['/community', this.communityData?.id, 'custom-grid']);
              }
            },
            error: (error) => {
              console.error('Error fetching table data', error);
            }
          });
        }
      }
    };
  }


  addCustomTheme(theme: any, userFriendlyThemeName: any) {
    registerCreatorTheme(theme);
  }

  saveSurvey() {
    if (this.surveyCreatorModel) {
      this.surveyCreatorModel.doSave();
    }
    this.showDialogBox = false;
    setTimeout(() => {
      this.smlModal?.closeModal();
    });
  }

  saveChanges() {
    if (!this.currentFormData.title || !this.currentFormData.title.trim()) {
      this.toastr.error({ message: 'Form Title cannot be empty or spaces only' });
      return;
    }
    this.isSaveClick = true;
    this.showDialogBox = true;
    setTimeout(() => {
      this.smlModal?.openModal();
    });;
  }

  onSaveChanges() {
    if (this.isSaveClick) {

      this.saveSurvey();
    }
    else if (this.isTemplateForm) {
      this.router.navigate(['/community', this.communityData?.id, 'custom-template-grid']);

    }
    else {
      this.router.navigate(['/community', this.communityData?.id, 'custom-grid']);
    }
  }

  cancelEditing() {
    if (window.innerWidth < 1500) {
      if (!this.isTemplateForm) {
        this.router.navigate(['/community', this.communityData?.id, 'custom-grid']);
        return;

      }
      else {
        this.router.navigate(['/community', this.communityData?.id, 'custom-template-grid']);
        return;
      }
    }
    this.isSaveClick = false;
    this.showDialogBox = true;
    setTimeout(() => {
      this.smlModal?.openModal();
    });
  }

  handleBackClick(event: any) {
    if (this.isTemplateForm) {
      this.router.navigate(['/community', this.communityData?.id, 'custom-template-grid']);

    }
    else {
      this.router.navigate(['/community', this.communityData?.id, 'custom-grid']);
    }
  }

  onCloseDialog() {
    this.showDialogBox = false;
    setTimeout(() => {
      this.smlModal?.closeModal();
    });
  }

  changeSettingNames() {
    const translations = getLocaleStrings("en");
    translations.ed.addNewQuestion = "Add Field";
    translations.ed.questionSettings = "Field Settings";
    translations.ed.questionTitle = "Field Title";
    translations.ed.questionTitleLocation = "Field title alignment";
    translations.ed.questionDescriptionLocation = "Field description alignment";
    translations.ed.questionNumbering = "Field numbering";
    translations.ed.questionTitlePattern = "Field title pattern";
    translations.ed.questionOrder = "Field order";
    translations.ed.requiredSymbol = "Required symbol(s)";
    translations.ed.errorMessageLocation = "Error message alignment";
    translations.pe.questionOrder = "Field order";
    translations.pe.questionTitleLocation = "Field title alignment";
    translations.pe.questionDescriptionLocation = "Field description alignment";
    translations.pe.questionNumbering = "Field numbering";
    translations.pe.questionTitlePattern = "Field title pattern";
    translations.pe.requiredSymbol = "Required symbol(s)";
    translations.pe.errorLocation = "Error message alignment"; // You may need this too
    translations.pe.questionSettings = "Field Settings";
    translations.pe.questionNumbering = "Field numbering";
    translations.ed.addNewQuestion = "Add Field"; // change tooltip/title text
    translations.pe.question.title = "Field Title";
    translations.pe.question.description = "Field Description";
    translations.qt.dropdown = "Single-Select Dropdown";
    translations.pe.panel.title = "Section Title";
    translations.pe.panel.description = "Section Description";
  }

  protectFields(creator: any) {
    const addressFields = ["City", "AddressLine1", "AddressLine2", "City", "State", "ZipCode",];

    creator.onElementAllowOperations.add((sender: any, options: any) => {
      const questionName = options.element.name;
      const fieldsToRestrict = ["FirstName", "LastName", "Email", "Phone",];
      if (fieldsToRestrict.includes(questionName)) {
        options.allowDelete = false;
        options.allowEdit = false;
        options.allowChangeType = false;
        options.allowCopy = false;
        options.allowChangeRequired = false; // Prevent changing required status
      }
      if (questionName == 'OrganizationBusinessName') {
        // options.allowDelete = false;
        options.allowChangeType = false;
        options.allowCopy = false;
      }
      if (addressFields.includes(questionName)) {
        options.allowDelete = false;
        // options.allowEdit = false;
        options.allowChangeType = false;
        options.allowCopy = false;
        // options.allowChangeRequired = true; // Prevent changing required status
      }
    });

    creator.onPropertyGetReadOnly.add((sender: any, options: any) => {
      if (
        ["name", "title"].indexOf(options.property.name) > -1 &&
        addressFields.includes(options.element.name)
      ) {
        options.readOnly = true;
      }
    });
  }

  changePanelName(creator: any) {
    creator.onSurveyInstanceCreated.add((sender: any, options: any) => {
      const panelItem = creator.toolbox.getItemByName("panel");
      if (panelItem) {
        panelItem.title = "New Section";
      }
    });
  }

  hideSaveButton(creator: any) {
    const saveButtonIndex = creator.toolbarItems.findIndex((item: any) => item.id === "svd-save");
    if (saveButtonIndex !== -1) {
      creator.toolbarItems.splice(saveButtonIndex, 1);
    }
    creator?.onElementAllowOperations?.add((_: any, options: any) => {
      if (options.element.getType() === 'panel' && options.element.name === 'ParticipantDetails') {
        options.allowCopy = false;
        options.allowDelete = false; // Disable delete for the ParticipantDetails panel
      }
      if (options.element.getType() === 'panel' && options.element.name === 'addressPanel') {
        options.allowCopy = false;
      }
      if (options.element.name === "DonorRecognitionImage" || options.element.name === "DonatedBy" || options.element.name === "DedicatedTo") {
        options.allowCopy = false;
      }
    });
  }

  addSurveyKey() {
    Survey.slk(env.surveyJsKey);
  }

  otherFunc(creator: any) {
    const restrictedFields = [
      "FirstName", "LastName", "Email", "Phone"
    ];
    const addressFields = [
      "AddressLine1", "AddressLine2", "City", "State", "ZipCode"
    ];

    creator.onShowingProperty.add((sender: any, options: any) => {
      const type = options.obj.getType && options.obj.getType();
      const inputType = options.obj.inputType;
      const fieldName = options.obj.name;

      if (restrictedFields.includes(fieldName)) {
        if (options.property.name === "title" || options.property.name === "isRequired") {
          options.canShow = false;
          return;
        }
      }

      if (addressFields.includes(fieldName)) {
        if (options.property.name === "title") {
          options.canShow = false;
          return;
        }
      }

      if (type === "survey") {
        options.canShow = true;
        return;
      }
      let allowedProps: string[] = [];
      switch (type) {
        case "text":
          if (inputType === "tel") {
            // Phone Number field
            allowedProps = ["title", "description", "isRequired"];
          } else if (inputType === "email") {
            // Email field
            allowedProps = ["title", "description", "placeholder", "isRequired"];
          } else if (inputType === "date" || inputType === "datetime-local" || inputType === "number") {
            // ✅ Date or DateTime field
            allowedProps = ["title", "description", "min", "max", "isRequired"];
          } else {
            // Regular text field
            allowedProps = ["title", "description", "isRequired", "placeholder", "maxLength"];
          }
          break;

        case "comment":
          allowedProps = ["title", "description", "isRequired", "placeholder", "maxLength"];
          break;

        case "dropdown":
        case "tagbox":
          allowedProps = ["title", "description", "isRequired", "placeholder", "choices"];
          break;

        case "checkbox":
          allowedProps = ["title", "description", "isRequired", "choices"];
          break;

        case "file":
          allowedProps = ["title", "description", "isRequired"];
          break;

        case "signaturepad":
          allowedProps = ["title", "description", "isRequired", "placeholder", "allowClear"];
          break;

        case "number":
          allowedProps = ["title", "description", "isRequired", "min", "max"];
          break;

        default:
          allowedProps = ["title", "description"];
          break;
      }
      if (!allowedProps.includes(options.property.name)) {
        options.canShow = false;
      }
    });
    ["min", "max"].forEach((prop) => {
      const p = Serializer.findProperty("text", prop);
      if (p) p.category = "general";
    });
    Serializer.findProperty("text", "maxLength",).category = "general";
    Serializer.findProperty("text", "maxLength",).defaultValue = null;
    Serializer.findProperty("text", "maskType").category = "general";
    Serializer.findProperty("text", "min").category = "general";
    Serializer.findProperty("text", "max").category = "general";
    Serializer.findProperty("text", "maskSettings").category = "general";
    Serializer.getProperty("panel", "title").isRequired = true;
  }

  showPreview() {
    this.participateService.showParticipate({
      schema: this.surveyCreator.text,
      description: this.currentFormData.description,
      title: this.currentFormData.title,
    });
  }

  toggleEditing() {
    if (!this.currentFormData.title || !this.currentFormData.title.trim()) {
      this.toastr.error({ message: 'Form Title cannot be empty or spaces only' });
      return;
    }
    this.isTitleEditing = !this.isTitleEditing;
  }

  hideFieldSettingsForGlobalForm(creator: any) {
    this.surveyCreator.onPropertyShowing.add((sender, options) => {
      const allowedProps = ["title"];
      if (
        options.obj &&
        options.obj.getType() === "survey" &&
        !allowedProps.includes(options.property.name)
      ) {
        options.canShow = false;
      }
    });
  }

  /**
   * Keeps the built-in special choices out of Checkbox / Multi Select Dropdown fields in
   * the builder. They are renameable, which lets a "Select All" row end up labelled like a
   * normal option while still selecting every choice in the live form.
   *
   * A row is only hidden while the question's own flag is still off, so fields in older
   * saved forms that already have one keep showing it here and keep working in the live
   * form. Drop an entry from the map below to allow that row again.
   */
  restrictSpecialChoices(creator: any) {
    const specialChoiceFlags: Record<string, string> = {
      selectAllItem: "hasSelectAll",
      noneItem: "showNoneItem",
      otherItem: "hasOther",
    };

    creator.onDesignerSurveyCreated.add((_: any, options: any) => {
      options.survey?.onShowingChoiceItem.add((__: any, choiceOptions: any) => {
        const question = choiceOptions.question as any;
        if (!question) return;
        for (const itemName of Object.keys(specialChoiceFlags)) {
          if (question[itemName] === choiceOptions.item && !question[specialChoiceFlags[itemName]]) {
            choiceOptions.visible = false;
            return;
          }
        }
      });
    });
  }

  addCustomFields(creator: any) {
    // List of custom fields you want to enforce single addition on
    const customFields = [
      {
        name: 'DonorRecognitionImage',
        trackName: 'DonorRecognitionImage',
        iconName: 'icon-smiley-rate10-24x24',
        title: 'Recognition Photo',
        category: "Public Recognition Fields",
        storeDataAsText: false,
        waitForUpload: true,
        json: {
          type: 'file',
          title: 'Recognition Photo',
          description: 'Share an image of yourself, your family, or a loved one. Or, upload a logo for your business/organization.',
          allowMultiple: false,
          acceptedTypes: '.jpg,.jpeg,.png,.webp,.jfif',
          showPreview: true,
          storeDataAsText: false,
          waitForUpload: true,
        }
      },
      {
        name: "addressPanel",
        trackName: 'addressPanel',
        iconName: "icon-smiley-rate3-24x24", // optional custom icon
        title: "Participant Address", // Title for the toolbox item
        category: "Basic Fields", // Or any category name you want
        json: {
          type: "panel",
          name: "addressPanel",
          title: "Participant Address",
          elements: [
            {
              type: "text",
              name: "AddressLine1",
              title: "Street Address",
              isRequired: false,
            },
            {
              type: "text",
              name: "AddressLine2",
              title: "Street Address 2",
              startWithNewLine: false,
            },
            {
              type: "text",
              name: "City",
              title: "City",
              isRequired: false,
            },
            {
              type: "text",
              name: "State",
              title: "State",
              isRequired: false,
              startWithNewLine: false,

            },
            {
              type: "text",
              name: "ZipCode",
              title: "Zip Code",
              isRequired: false,
              startWithNewLine: false,

            }
          ]
        }
      },
      {
        name: "DedicatedTo",
        trackName: 'DedicatedTo',
        iconName: "icon-smiley-rate2-24x24", // optional custom icon
        title: "Dedicated To",
        category: "Public Recognition Fields",
        json: {
          type: "text",
          name: "DedicatedTo",
          title: "Dedicated To",
          description: 'Add the name of the person, family, group, or cause that this contribution honors.',
          isRequired: false,
        }
      },
      {
        name: "DonatedBy",
        trackName: 'DonatedBy',
        iconName: "icon-smiley-rate1-24x24", // optional custom icon
        title: "Donated By",
        category: "Public Recognition Fields",
        json: {
          type: "text",
          name: "DonatedBy",
          title: "Donated By",
          description: 'Share your full name, family name, or organization name to be shared on your Contribution.',
          isRequired: false,
        }
      },
      {
        name: "OrganizationBusinessName",
        trackName: 'OrganizationBusinessName',
        iconName: "icon-toolbox-singleline-24x24",
        title: "Organization Name",
        category: "Basic Fields",
        // targetPanel: "ParticipantDetails", // Specify target panel
        json: {
          type: "text",
          name: "OrganizationBusinessName",
          title: "Organization, Business, or Family Name",
          description: "Participating as a group? List name here.",
          isRequired: false,
        }
      }
      // Add more here...
    ];

    const customDefaultFields = [
      {
        name: 'Checkbox',
        trackName: 'Checkbox',
        category: 'Basic Fields',
        iconName: 'icon-toolbox-checkbox-24x24',
        title: 'Checkbox',
        json: {
          type: 'checkbox',
          title: 'Checkbox',
          choices: [
            "Item 1",
            "Item 2",
            "Item 3"
          ],
          colCount: 2
        }
      },
      {
        name: 'SingleSelectDropdown',
        trackName: 'SingleSelectDropdown',
        iconName: 'icon-toolbox-dropdown-24x24',
        title: 'Single Select Dropdown',
        category: 'Basic Fields',
        json: {
          type: 'dropdown',
          title: 'Select an Option',
          choices: [
            "Option A",
            "Option B",
            "Option C"
          ]
        }
      },
      {
        name: 'MultiSelectDropdown',
        trackName: 'MultiSelectDropdown',
        iconName: 'icon-toolbox-tagbox-24x24',
        title: 'Multi Select Dropdown',
        category: 'Basic Fields',
        json: {
          type: 'tagbox',
          title: 'Select Multiple Options',
          choices: [
            "Option A",
            "Option B",
            "Option C"
          ],
          isRequired: false,
        }
      },
      {
        name: 'FileUpload',
        trackName: 'FileUpload',
        iconName: 'icon-toolbox-file-16x16',
        title: 'File Upload',
        category: 'Basic Fields',
        storeDataAsText: false,
        waitForUpload: true,
        json: {
          type: 'file',
          title: 'File Upload',
          allowMultiple: true,
          acceptedTypes: '.jpg,.jpeg,.png,.pdf,.docx,.xlsx,.txt',
          showPreview: true,
          storeDataAsText: false,
          waitForUpload: true,
        }
      },
      {
        name: 'Phone',
        trackName: 'Phone',
        iconName: 'icon-smiley-rate5-24x24',
        title: 'Phone Number',
        category: 'Basic Fields',
        json: {
          type: 'text',
          inputType: 'tel',
          title: 'Phone',
          maskType: "pattern",
          maskSettings: {
            "pattern": "(999) 999-9999"
          }
        }
      },
      {
        name: 'Email',
        trackName: 'Email',
        iconName: 'icon-smiley-rate4-24x24',
        title: 'Email',
        category: 'Basic Fields',
        json: {
          type: 'text',
          inputType: 'email',
          title: 'Email',
        }
      },
      // 3. Signature Field
      {
        name: 'SignatureField',
        trackName: 'SignatureField',
        iconName: 'icon-toolbox-signature-24x24',
        title: 'Signature Field',
        category: 'Basic Fields',
        json: {
          type: 'signaturepad',
          title: 'Signature',
          isRequired: false,
          signatureWidth: 1000
        }
      }
    ];

    for (const field of customDefaultFields) {
      // this.itemState[field.trackName] = false;
      creator.toolbox.addItem({
        name: field.name,
        title: field.title,
        iconName: field.iconName,
        category: field.category,
        type: 'Custom',
        json: {
          name: field.trackName,
          ...field.json
        },
        enabled: true
      });
    }


    // 1. Add each to toolbox
    for (const field of customFields) {
      this.itemState[field.trackName] = false;
      creator.toolbox.addItem({
        name: field.name,
        title: field.title,
        iconName: field.iconName,
        category: field.category,
        type: 'Custom',
        json: {
          name: field.trackName,
          ...field.json
        },
        enabled: true
      });
    }

    // 2. Helper: Update enable/disable status
    const updateToolboxState = (itemName: string, enabled: boolean) => {
      const item = creator.toolbox.getItemByName(itemName);
      if (item) item.enabled = enabled;
    };

    // 3. Handle when question is added
    creator.onQuestionAdded.add((_: any, options: any) => {
      const added = options.question;
      for (const field of customFields) {
        const match =
          added.getType() === field.json.type &&
          added.title === field.json.title;
        if (match) {
          // Forcefully rename to stable name if it has changed
          if (added.name !== field.trackName) {
            added.name = field.trackName;
          }
          if (!this.itemState[field.trackName]) {
            this.itemState[field.trackName] = true;
            updateToolboxState(field.name, false);
          }
          break;
        }
      }
    });

    function findElementByName(elements: any[], name: string): boolean {
      for (const el of elements) {
        if (el.name === name) return true;
        if (el.elements) {
          if (findElementByName(el.elements, name)) return true;
        }
      }
      return false;
    }

    // 4. Handle when question is removed
    creator.onModified.add(() => {
      const rootElements = creator.survey.pages.flatMap((p: any) => p.elements);
      for (const field of customFields) {
        const exists = findElementByName(rootElements, field.trackName);
        if (exists && !this.itemState[field.trackName]) {
          this.itemState[field.trackName] = true;
          updateToolboxState(field.name, false);  // Disable
        }
        if (!exists && this.itemState[field.trackName]) {
          this.itemState[field.trackName] = false;
          updateToolboxState(field.name, true);   // Enable
        }
        if (!exists && !this.itemState[field.trackName]) {
          this.itemState[field.trackName] = false;
          updateToolboxState(field.name, true);   // Enable
        }
      }
    });

    for (const field of customFields) {
      if (this.savedItemState && this.savedItemState[field.trackName]) {
        updateToolboxState(field.name, false);  // Disable the item if it was previously disabled
      } else {
        updateToolboxState(field.name, true);   // Enable the item if it was previously enabled
      }
    }
  }
  

  // Helper method to check if a field exists in the current form
  checkIfFieldExistsInForm(fieldName: string): boolean {
    const survey = this.surveyCreator?.survey;
    if (!survey) return false;
    
    // Check all pages and their elements
    for (const page of survey.pages) {
      for (const element of page.elements) {
        // Check direct elements
        if (element.name === fieldName) return true;
        
        // Check nested elements (panels)
        if (element.getType() === 'panel' && (element as any).elements) {
          for (const nested of (element as any).elements) {
            if (nested.name === fieldName) return true;
          }
        }
      }
    }
    return false;
  }

  changeAddQuestion(creator: any) {
    let fieldCount = 1;
    creator.onQuestionAdded?.add((_: any, options: any) => {
      const element = options.question;
      if (element && element.name?.startsWith("DonorRecognitionImage") || element.name?.startsWith("DedicatedTo") || element.name?.startsWith("ParticipantAddress") || element.name?.startsWith("DonatedBy") || element.name?.startsWith("OrganizationBusinessName")) {
        return;
      }
      if (element && element.name) {
        element.title = `Field ${fieldCount}`;
        fieldCount++;
      }
    });
  }

  setLastModifiedData(data: any) {
    if (data.updatedOn) {
      const date = new Date(data?.updatedOn);
      const formattedDate = date.toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      this.lastModified = formattedDate.replace(",", " |");
    }
  }
}

